import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { Tree, Row, Col } from "antd";
import releaseNotesImg from './releaseNotes.png';
import { DownOutlined } from "@ant-design/icons";
import "./style.css";

const ReleaseNotes = () => {
  const [selectedReleaseVer, setSelectedReleaseVer] = useState(null);

  const treeData = [
    {
      title: "Version 1.0",
      key: "1-0-0"
    },
    {
      title: "Version 2.0",
      key: null,
      children: [
        {
          title: "2.0.0",
          key: "2-0-0"
        },
        {
          title: "2.0.1",
          key: "2-0-1"
        },
        {
          title: "2.0.2",
          key: "2-0-2"
        },
      ]
    },
    {
      title: "Version 3.0",
      key: null,
      children: [
        {
          title: "3.0.0",
          key: "3-0-0"
        },
        {
          title: "3.0.1",
          key: "3-0-1"
        },
        {
          title: "3.0.2",
          key: "3-0-2"
        },
        {
          title: "3.0.3",
          key: "3-0-3"
        },
        {
          title: "3.0.4",
          key: "3-0-4"
        },
      ]
    },
    {
      title: "Version 4.0",
      key: null,
      children: [
        {
          title: "4.0.0",
          key: "4-0-0"
        },
        {
          title: "4.0.1",
          key: "4-0-1"
        },
        {
          title: "4.1.0",
          key: "4-1-0"
        },
        {
          title: "4.1.1",
          key: "4-1-1"
        },
        {
          title: "4.1.2",
          key: "4-1-2"
        },
        {
          title: "4.1.3",
          key: "4-1-3"
        },
        {
          title: "4.1.4",
          key: "4-1-4"
        },
        {
          title: "4.2.0",
          key: "4-2-0"
        },
        {
          title: "4.3.0",
          key: "4-3-0"
        },
        {
          title: "4.3.1",
          key: "4-3-1"
        },
        {
          title: "4.4.0",
          key: "4-4-0"
        },
      ]
    },
  ];
  
  const releaseNotesData = {
    '1-0-0': `
      <p><b>1.0.0</b></p>
      <p><u>Oct 01, 2023</u></p>
      <p>This is the soft release of the CRP Menu Project website.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Home</li>
        <li>About</li>
        <li>Workshops</li>
        <li>Team</li>
        <li>Contact Us</li>
      </ul>
    `,
    '2-0-0': `
      <p><b>2.0.0</b></p>
      <p><u>Apr 01, 2024</u></p>
      <p>This is the soft release of the CRP Menu Tool with the new Explore Practices features.</p>
      <p>Updated Features:</p>
      <ul>
        <li>CRP Basics</li>
        <li>Explore Practices</li>
        <li>Contact Us</li>
      </ul>
    `,
    '2-0-1': `
      <p><b>2.0.1</b></p>
      <p><u>Aug 08, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>CRP Basics</li>
        <li>Team</li>
      </ul>
    `,
    '2-0-2': `
      <p><b>2.0.2</b></p>
      <p><u>Aug 14, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>CRP Basics</li>
        <li>Practice Details</li>
      </ul>
    `,
    '3-0-0': `
      <p><b>3.0.0</b></p>
      <p><u>Sep 23, 2024</u></p>
      <p>This is a major update release with the new Check Eligibility features.</p>
      <p>Updated Features:</p>
      <ul>
        <li>CRP Basics</li>
        <li>Explore Practices</li>
        <li>Practice Details</li>
        <li>Check Eligibility</li>
        <li>Workshops</li>
      </ul>
    `,
    '3-0-1': `
      <p><b>3.0.1</b></p>
      <p><u>Oct 9, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>CRP Basics</li>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
        <li>Team</li>
      </ul>
    `,
    '3-0-2': `
      <p><b>3.0.2</b></p>
      <p><u>Oct 17, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Check Eligibility</li>
        <li>Workshops</li>
        <li>User Account</li>
      </ul>
    `,
    '3-0-3': `
      <p><b>3.0.3</b></p>
      <p><u>Oct 22, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Check Eligibility</li>
        <li>Workshops</li>
        <li>User Registration</li>
      </ul>
    `,
    '3-0-4': `
      <p><b>3.0.4</b></p>
      <p><u>Oct 31, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Check Eligibility</li>
        <li>User Account</li>
      </ul>
    `,
    '4-0-0': `
      <p><b>4.0.0</b></p>
      <p><u>Nov 8, 2024</u></p>
      <p>This is a major update release with the new expansion states. New states added: Iowa.</p>
      <p>Updated Features:</p>
      <ul>
        <li>About</li>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
        <li>User Account</li>
      </ul>
    `,
    '4-0-1': `
      <p><b>4.0.1</b></p>
      <p><u>Nov 18, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Workshops</li>
      </ul>
    `,
    '4-1-0': `
      <p><b>4.1.0</b></p>
      <p><u>Dec 6, 2024</u></p>
      <p>This is a major update release with the new expansion states. New states added: Indiana, Ohio.</p>
      <p>Updated Features:</p>
      <ul>
        <li>CRP Basics</li>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
      </ul>
    `,
    '4-1-1': `
      <p><b>4.1.1</b></p>
      <p><u>Dec 20, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Workshops</li>
      </ul>
    `,
    '4-1-2': `
      <p><b>4.1.2</b></p>
      <p><u>Feb 3, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Workshops</li>
      </ul>
    `,
    '4-1-3': `
      <p><b>4.1.3</b></p>
      <p><u>Feb 6, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Check Eligibility</li>
      </ul>
    `,
    '4-1-4': `
      <p><b>4.1.4</b></p>
      <p><u>Feb 14, 2024</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Check Eligibility</li>
      </ul>
    `,
    '4-2-0': `
      <p><b>4.2.0</b></p>
      <p><u>Feb 21, 2025</u></p>
      <p>This is a major update release with the new expansion states. New states added: Arkansas, Louisiana.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
      </ul>
    `,
    '4-3-0': `
      <p><b>4.3.0</b></p>
      <p><u>Feb 26, 2025</u></p>
      <p>This is a major update release with the new practice ranking scheme.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
      </ul>
    `,
    '4-3-1': `
      <p><b>4.3.1</b></p>
      <p><u>Mar 4, 2025</u></p>
      <p>This is a minor update release.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
        <li>Workshops</li>
      </ul>
    `,
    '4-4-0': `
      <p><b>4.4.0</b></p>
      <p><u>Apr 11, 2025</u></p>
      <p>This is a major update release with the new interactive tutorial for first-time users.</p>
      <p>Updated Features:</p>
      <ul>
        <li>Explore Practices</li>
        <li>Check Eligibility</li>
        <li>Workshops</li>
      </ul>
    `,
  };

  const onSelect = (selectedKeys, info) => {
    if (selectedKeys[0]) {
      setSelectedReleaseVer(releaseNotesData[selectedKeys[0]]);
    }
  };

  return (
    <>
      <Row>
        <Col offset={2} span={20} className="mt-3">
          <h3 className="mt-3"><center>CRP Menu Tool - Release notes</center></h3>
          <p className="mt-3">
            We're thrilled to announce the soft release of this new CRP Menu Tool!
            Please see below for the milestones and released features:
          </p>
        </Col>
      </Row>
      <Row>
        <Col offset={2} span={4}>
          <h3 className="releaseTreeTitle">Versions:</h3>
          <Tree
            className="releaseTree"
            showLine
            switcherIcon={<DownOutlined />}
            defaultExpandedKeys={["0-0-0"]}
            onSelect={onSelect}
            treeData={treeData}
          />
        </Col>
        <Col span={18}>
          {selectedReleaseVer && <div className="releaseNotesDesc"> {parse(selectedReleaseVer)}</div>}
          {/* {!selectedReleaseVer && <img src={releaseNotesImg} className="releaseNotesImg" />} */}
        </Col>
      </Row>
    </>
  );
};

export default ReleaseNotes;
